'use client';

import { Toast, ToastProvider, ToastViewport } from '../Toast';
import { createPortal } from 'react-dom';
import { useToast } from 'shared/hooks/useToast';

const Toaster = () => {
  const { toasts } = useToast();

  // Ported to a body-level sibling of #root: Headless UI's Dialog marks #root inert and treats
  // clicks inside it as "outside" the dialog, so a toast rendered inline there would be
  // non-interactive (and closing a modal on click) while a Dialog is open.
  return createPortal(
    <ToastProvider swipeDirection="right">
      {toasts.map(({ id, ...props }) => {
        return <Toast key={id} {...props} />;
      })}
      <ToastViewport />
    </ToastProvider>,
    document.body
  );
};

export { Toaster };
